import { haptic } from '@/lib/telegram';
import clsx from 'clsx';
import styles from './Tabs.module.css';

interface Tab<T extends string> {
  value: T;
  label: string;
  count?: number;
}

interface Props<T extends string> {
  value: T;
  onChange: (v: T) => void;
  tabs: Tab<T>[];
}

export function Tabs<T extends string>({ value, onChange, tabs }: Props<T>) {
  return (
    <div className={styles.scroll}>
      <div className={styles.track}>
        {tabs.map((tab) => {
          const isActive = tab.value === value;
          return (
            <button
              key={tab.value}
              onClick={() => { haptic.selection(); onChange(tab.value); }}
              className={clsx(styles.tab, isActive && styles.tabActive)}
            >
              {tab.label}
              {tab.count !== undefined && (
                <span className={styles.count}>{tab.count}</span>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}